import { ApolloError } from '@apollo/client'
import { GraphQLFormattedError } from 'graphql'

export function hasGraphQLErrorCode(
  apolloError: ApolloError,
  errorCode: string | string[]
): GraphQLFormattedError | undefined {
  const codes = Array.isArray(errorCode) ? errorCode : [errorCode]
  return apolloError.graphQLErrors.find(error =>
    codes.includes(error.extensions?.code)
  )
}
